// src/components/spot/BalanceSlider.js
import React, { useState } from 'react';
import { Box, Slider, Typography, useTheme } from '@mui/material';

const BalanceSlider = ({ availableBalance, setAmount, price, tradeType }) => {
  const theme = useTheme();
  const [percentage, setPercentage] = useState(0);

  const handleSliderChange = (event, newValue) => {
    setPercentage(newValue);
    let newAmount;
    if (tradeType === 'Buy') {
      // For Buy: Calculate amount as (percentage of USDT balance) / price
      newAmount = ((newValue / 100) * availableBalance) / (parseFloat(price) || 1);
    } else {
      // For Sell: Calculate amount as percentage of base asset balance
      newAmount = (newValue / 100) * availableBalance;
    }
    setAmount(newAmount.toFixed(4));
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 1 }}>
        Use Percentage of Balance: {percentage}%
      </Typography>
      <Slider
        value={percentage}
        onChange={handleSliderChange}
        aria-label="Balance percentage"
        valueLabelDisplay="auto"
        step={5}
        marks
        min={0}
        max={100}
        sx={{
          color: tradeType === 'Buy' ? '#00C087' : '#F6465D',
          '& .MuiSlider-thumb': {
            bgcolor: tradeType === 'Buy' ? '#00C087' : '#F6465D',
          },
          '& .MuiSlider-rail': {
            bgcolor: theme.palette.mode === 'dark' ? '#2A2F42' : '#E0E0E0',
          },
        }}
      />
    </Box>
  );
};

export default BalanceSlider;